import { utils, writeFile } from "xlsx"
import { BulkLabel } from "@app/services/types"

export type ExportType = "excel" | "csv"

type ExportData = {
	bulkLabels: BulkLabel[]
	batchId: number
	exportType: ExportType
}

const prepareBulkLabelsForExport = (bulkLabels: BulkLabel[]) => {
	return bulkLabels.map((label) => ({
		"Bulk ID": label.bulk_label,
		"Cat Class": label.part_number,
		Description: label.description,
	}))
}

export const exportBulkLabels = ({ bulkLabels, batchId, exportType }: ExportData) => {
    const data = prepareBulkLabelsForExport(bulkLabels)
	const worksheet = utils.json_to_sheet(data)
	const workbook = utils.book_new()
	utils.book_append_sheet(workbook, worksheet, "Bulk Labels")

	const date = new Date().toLocaleDateString().replace(/\//g, "-")
	const fileName = `bulk_labels_batch_${batchId}_${date}`

	if (exportType === "excel") {
		writeFile(workbook, `${fileName}.xlsx`)
	} else {
		writeFile(workbook, `${fileName}.csv`)
	}
}
